export default "__VITE_ASSET__d6c0fe39__"